import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-stage-deep contour text-center text-white" aria-label="Oferta por tiempo limitado" data-id="element-267" data-mp="369xubzheqcj6">
      <div className="tick-bar h-3 w-full" aria-hidden="true" data-id="element-268" data-mp="31jhd04agu6rj" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-269" data-mp="31h4o176aiw4z">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-danger" data-id="element-270" data-mp="3g7c6hmwasf5o">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-271" data-mp="3b893e7zvoj0c" /> El precio de lanzamiento termina en
        </p>
        <Countdown light className="mt-5 scale-110" data-id="element-272" data-mp="3p80n8pd2stm9" />
        <p className="mt-7 font-bold text-mutedDark" data-id="element-273" data-mp="3l6ymu57fabip">Después sube el precio y no vuelve a bajar.</p>

        <div className="panel-dark mx-auto mt-6 max-w-xl rounded-lg border border-steel p-4 text-sm" data-id="element-274" data-mp="1uu0sxbsdu052">
          <p className="font-bold" data-id="element-275" data-mp="1qtz3c0zx8x65">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-danger" data-id="element-276" data-mp="1qv0b9wln53jn" />
            Cupos al precio de lanzamiento: quedan pocos
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-black/40" data-id="element-277" data-mp="2xtsqfkkva057">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-yellow" data-id="element-278" data-mp="32rc3ih5tw6vk" />
          </div>
          <p className="mt-1 text-right text-xs text-mutedDark" data-id="element-279" data-mp="3gi7j0cau1m84">66% de los cupos tomados</p>
        </div>
      </div>
      <div className="tick-bar h-3 w-full" aria-hidden="true" data-id="element-280" data-mp="3liv7orbl9qz6" />
    </section>;
}